import '../../style/index.less';
import './index.less'; // style dependencies

import '../../button/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/modal/style/index.js
// module id = 1447
// module chunks = 0